// @flow
import { WritesonicActionTypes } from './constants';

const INIT_STATE = {
    ideas: [],
    intro: [],
    outlines: [],
    article: {},
    expandedText: [],
    instantWriterItem: {},
    paragraph: [],
    image: [],
    loading: false,
    error: false,
    formSubmited: false
}

type WritesonicAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { ideas?: Array<any> | null, intro?: Array<any> | null, outlines?: Array<any> | null, article?: any, expandedText?: Array<any> | null, instantWriterItem?: any, paragraph?: Array<any> | null, image?: Array<any> | null, loading?: boolean, error?: boolean, formSubmited?: boolean };

const Writesonic = (state: State = INIT_STATE, action: WritesonicAction): any => {
    // console.log(action);
    switch (action.type) {
        case WritesonicActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case WritesonicActionTypes.GET_IDEAS: {
                    return {
                        ...state,
                        ideas: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.GET_INTRO: {
                    return {
                        ...state,
                        intro: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.GET_OUTLINES: {
                    return {
                        ...state,
                        outlines: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.WRITE_ARTICLE: {
                    return {
                        ...state,
                        article: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.EXPAND_TEXT: {
                    return {
                        ...state,
                        expandedText: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.INSTANT_WRITER: {
                    return {
                        ...state,
                        instantWriterItem: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.WRITE_PARAGRAPH: {
                    return {
                        ...state,
                        paragraph: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.GENERATE_IMAGE: {
                    return {
                        ...state,
                        image: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case WritesonicActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case WritesonicActionTypes.GET_IDEAS: {
                    return {
                        ...state,
                        ideas: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.GET_INTRO: { 
                    return {
                        ...state,
                        intro: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.GET_OUTLINES: {
                    return {
                        ...state,
                        outlines: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.WRITE_ARTICLE: {
                    return {
                        ...state,
                        article: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.EXPAND_TEXT: {
                    return {
                        ...state,
                        expandedText: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.INSTANT_WRITER: {
                    return {
                        ...state,
                        instantWriterItem: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.WRITE_PARAGRAPH: {
                    return {
                        ...state,
                        paragraph: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case WritesonicActionTypes.GENERATE_IMAGE: {
                    return {
                        ...state,
                        image: [],
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case WritesonicActionTypes.GET_IDEAS:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.GET_INTRO:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.GET_OUTLINES:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.WRITE_ARTICLE:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.EXPAND_TEXT:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.INSTANT_WRITER:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.WRITE_PARAGRAPH:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.GENERATE_IMAGE:
            return { ...state, error: false, loading: true };
        case WritesonicActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                ideas: [],
                intro: [],
                outlines: [],
                article: {},
                expandedText: [],
                instantWriterItem: {},
                paragraph: [],
                image: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Writesonic;
